import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestApi } from '../RestApi/restApi';

interface ProductsAssignedToRoles {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class ProductsAssignedToRolesService {
 private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private restAPI: RestApi,
  ) {
  }

   public retrieveProductsAssignedToRoles(userRoleId:any) {
    return this.http.get<ProductsAssignedToRoles>(this.restAPI.GET_PRODUCTS_FOR_ROLE + '/' + userRoleId, {headers: this.headers});
  }

  public insertProductsAssignedToRoles(ProductDetails:any) {
    return this.http.post<ProductsAssignedToRoles>(this.restAPI.INSERT_PRODUCTS_FOR_ROLE,JSON.stringify(ProductDetails),{headers: this.headers});
  }

   public insertProductGroup(ProductGroupDetails:any) {
    return this.http.post<ProductsAssignedToRoles>(this.restAPI.CREATE_PRODUCT_GROUP,JSON.stringify(ProductGroupDetails),{headers: this.headers});
  }
  
  public retrieveProductGroupList() {
    return this.http.get<ProductsAssignedToRoles>(this.restAPI.GET_PRODUCT_GROUP, {headers: this.headers});
  }

   public retrieveProductListByProductGroupId(productGroupId) {
    return this.http.get<ProductsAssignedToRoles>(this.restAPI.GET_PRODUCTS_BY_PRODUCT_GROUP_ID+'/'+productGroupId, {headers: this.headers});
  }

   public insertProductsByProductGroupId(ProductDetails:any) {
    return this.http.post<ProductsAssignedToRoles>(this.restAPI.INSERT_PRODUCTS_BY_PRODUCT_GROUP_ID,JSON.stringify(ProductDetails),{headers: this.headers});
  }

  public retrieveProductGroupToRoles(userRoleId:any) {
    return this.http.get<ProductsAssignedToRoles>(this.restAPI.GET_PRODUCT_GROUPS_BY_ROLE + '/' + userRoleId, {headers: this.headers});
  }

   public insertProductGroupByRole(ProductGroupDetails:any) {
    return this.http.post<ProductsAssignedToRoles>(this.restAPI.INSERT_PRODUCT_GROUP_BY_ROLE,JSON.stringify(ProductGroupDetails),{headers: this.headers});
  }
  
  public deleteProductGroup(productGroupId) {
    return this.http.get<ProductsAssignedToRoles>(this.restAPI.DELETE_PRODUCT_GROUP+'/'+productGroupId, {headers: this.headers});
  }
}
